import * as React from 'react';

function SvgFlashOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M14.789 2.045L5 14.143h5.714l-1.406 7.733a.106.106 0 00.104.124v0a.106.106 0 00.084-.042l9.79-12.1H13.57l1.414-7.735a.11.11 0 00-.11-.123v0a.108.108 0 00-.086.045v0z" })));
}

export default SvgFlashOutline;
